export default {"src":"/_next/static/media/PlayBtn.a0946b06.svg","height":143,"width":143,"blurWidth":0,"blurHeight":0};